import React, { useContext, useMemo, useState } from 'react';

// Wizard-scoped shared state (segment -> org -> location), per the agreed state
// boundary: Context for multi-step flows, RHF inside each step's form.
const OnboardingContext = React.createContext(null);

const initialDraft = {
  segment: null,
  name: '',
  contact_email: '',
  contact_phone: '',
  // Default to the browser's IANA zone so displayed dates aren't silently UTC.
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
  location_name: '',
  location_address: '',
  location_city: '',
  location_region: '',
  location_postal_code: '',
};

function OnboardingProvider({ children }) {
  const [draft, setDraft] = useState(initialDraft);

  const contextValue = useMemo(() => ({
    draft,
    update: (values) => setDraft((prev) => ({ ...prev, ...values })),
  }), [draft]);

  return <OnboardingContext.Provider value={contextValue}>{children}</OnboardingContext.Provider>;
}

function useOnboarding() {
  return useContext(OnboardingContext);
}

OnboardingProvider.displayName = 'OnboardingProvider';
export { OnboardingProvider, useOnboarding };
